import { c as _c } from "react/compiler-runtime";
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { PRODUCT_OPTIONS } from 'data-hooks/queries';
const usePDPQueryOptionsForProduct = (t0, t1) => {
  const $ = _c(16);
  const {
    id,
    slug,
    initialProductOptions: productOptions
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    skip
  } = t2;
  let t3;
  if ($[2] !== id || $[3] !== slug) {
    t3 = id ? {
      id
    } : slug ? {
      slug
    } : {};
    $[2] = id;
    $[3] = slug;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const variables = t3;
  const shouldSkip = skip || !id && !slug || !!productOptions;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      noBatch: true
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== shouldSkip || $[7] !== variables) {
    t5 = {
      variables,
      skip: shouldSkip,
      context: t4
    };
    $[6] = shouldSkip;
    $[7] = variables;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    loading,
    error,
    data
  } = useSuspenseQuery(PRODUCT_OPTIONS, t5);
  if (productOptions) {
    let t6;
    if ($[9] !== productOptions) {
      t6 = {
        loading: false,
        error: null,
        data: productOptions,
        skipProductOptionsQuery: false
      };
      $[9] = productOptions;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  const t6 = loading && !data;
  let t7;
  if ($[11] !== data || $[12] !== error || $[13] !== shouldSkip || $[14] !== t6) {
    t7 = {
      loading: t6,
      error,
      data,
      skipProductOptionsQuery: shouldSkip
    };
    $[11] = data;
    $[12] = error;
    $[13] = shouldSkip;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default usePDPQueryOptionsForProduct;